module.exports = __webpack_public_path__ + "img/button-home5.f1b88022.jpeg";